const PAYPAL_ROW_LIMIT = 5000;
const NOTE = "Webinity referral commission";

// PayPal Payouts Web: period for USD-like currencies, quoted comma for
// currencies that use a comma (EUR, BRL, and PLN).
const COMMA_DECIMAL_CURRENCIES = new Set([
  "BRL",
  "EUR",
  "PLN",
]);

const csvCell = (value) => {
  const text = String(value ?? "");

  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }

  return text;
};

const formatAmount = (minorUnits, currency) => {
  const major = (minorUnits / 100).toFixed(2);

  if (COMMA_DECIMAL_CURRENCIES.has(currency)) {
    return `"${major.replace(".", ",")}"`;
  }

  return major;
};

const payoutRows = (users) => {
  const byCurrency = new Map();

  (users || []).forEach((user) => {
    const email = String(user?.email || "").trim();
    const customerId = String(user?.id || "")
      .replace(/\s/g, "")
      .slice(0, 30);

    if (!email || !customerId) return;

    const totals = new Map();

    (user?.wallet || []).forEach((item) => {
      const currency = String(item?.currency || "")
        .trim()
        .toUpperCase();
      const amount = Number(item?.amount) || 0;

      if (!currency || amount <= 0) return;

      totals.set(currency, (totals.get(currency) || 0) + amount);
    });

    totals.forEach((amount, currency) => {
      const row = [
        csvCell(email),
        formatAmount(amount, currency),
        currency,
        csvCell(customerId),
        csvCell(NOTE),
        "PAYPAL",
        "",
        "",
        "",
        "AWARDS",
      ].join(",");

      const rows = byCurrency.get(currency) || [];
      rows.push(row);
      byCurrency.set(currency, rows);
    });
  });

  return byCurrency;
};

const payoutFiles = (users, date = new Date()) => {
  const stamp = [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");

  const files = [];

  [...payoutRows(users).entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .forEach(([currency, rows]) => {
      const chunks = Math.ceil(rows.length / PAYPAL_ROW_LIMIT) || 1;

      for (let index = 0; index < chunks; index += 1) {
        const part = rows.slice(
          index * PAYPAL_ROW_LIMIT,
          (index + 1) * PAYPAL_ROW_LIMIT,
        );
        const suffix = chunks > 1 ? `-${index + 1}` : "";

        files.push({
          filename: `paypal-payouts-${currency}-${stamp}${suffix}.csv`,
          content: `${part.join("\n")}\n`,
        });
      }
    });

  return files;
};

const hasPayableWallet = (users) =>
  (users || []).some((user) =>
    (user?.wallet || []).some((item) => Number(item?.amount) > 0 && item?.currency),
  );

export { payoutFiles, hasPayableWallet };
